var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("UPLOAD FILES")]),_c('input',{ref:"elInputFile",attrs:{"type":"file","multiple":""}}),_c('app-button-submit',{on:{"click":_vm.upload}},[_vm._v("Subir")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }